import React from "react";
import Home from "./home";


export default function Index(props){
  return (
    <Home />
  );
}